<template>
    <v-card elevation="0">
        <v-card-title class="pl-4 pb-6">{{ $t('lang_GENERIC_CAPTION_DATA_SHARING_NOTIFICATIONS') }}</v-card-title >
        <template class="mb-3" v-for="(notification) in notifications">
            <div class="mb-3">
                <v-card-subtitle class="py-0 font-weight-medium">
                    {{ notification.isSender ? $t('lang_GENERIC_CAPTION_RECIPIENT') : $t('lang_ERP_SHIPPING_CAPTION_SENDER_ABBREVIATION') }}: {{ getSenderReceiverName(notification) }}
                </v-card-subtitle>
                <v-card-text class="pb-0">
                    <p class="mb-1">
                        {{ $t('lang_GENERIC_CAPTION_DOMAIN') }}: {{ getDomainName(notification) }}
                    </p>
                    <p class="mb-1" v-if="notification.isSender">
                        {{$t('lang_ACCOUNT_MODULES_CAPTION_STATUS')}}: 
                        <BaseTooltip>
                            <template v-slot:content>{{ getStatusName(notification) }}</template>
                            <template v-slot:text><span v-if="notification.status == 'accepted'">{{ $t('lang_GENERIC_CAPTION_ENTERED_BY') }}: {{ notification.receiverUserName }}</span><span v-else>{{ getStatusName(notification) }}</span></template>
                        </BaseTooltip>
                    </p>
                    <p class="mb-1">
                        {{ $t('lang_GENERIC_CAPTION_DATA_SHARING_SCOPE') }}: {{ $n(notification.numberOfItems) }} {{ getItemName(notification) }}
                    </p>
                    <p class="mb-1" v-if="notification.status == 'accepted'">
                        <a href="#" @click="searchByTag(notification)">{{ notification.isReceiver ? $t('lang_DASHBOARD_CAPTION_SEARCH_FOR_RECEIVED_DATA') : $t('lang_DASHBOARD_CAPTION_SEARCH_FOR_SENT_DATA') }}</a>
                    </p>
                </v-card-text>
                <v-card-actions class="pl-4 pt-0" v-if="showActionsOnNotification(notification)">
                    <BaseButton 
                        label="lang_GENERIC_CAPTION_DECLINE" 
                        color="grey"
                        @click="declineRequest(notification)"
                    />
                    <BaseButton 
                        label="lang_GENERIC_CAPTION_ACCEPT"
                        @click="acceptRequest(notification)"
                    />
                </v-card-actions>
                <v-card-actions class="pl-4 pt-0" v-else>
                    <a href="#" @click="dismissNotification(notification)">{{ $t('lang_GENERIC_CAPTION_DISMISS') }}</a>
                </v-card-actions>
            </div>
        </template>
    </v-card>   
</template>
 
<script>
 // +  $d(new Date(notification.time), 'alvDateFormat')
import BaseButton from '../../../components/_buttons/BaseButton.vue'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "DataSharingNotificationCard",
    components: {
        BaseButton,
        BaseTooltip
    },
    props: {
        notifications:Array
    },
    data() {
        return {
            acceptEndpoint: "dataSharing/accept",
            declineEndpoint: "dataSharing/decline"
        }
    },
    methods: {
        async declineRequest(notification) {
            await this.$store.dispatch('declineDataSharingRequest', { requestId: notification.id })
        },
        async acceptRequest(notification) {
            await this.$store.dispatch('acceptDataSharingRequest', { requestId: notification.id })
        },
        getSenderReceiverName(notification) {
            return notification.isSender ? notification.receiverName : notification.senderName
        },
        getDomainName(notification) {
            let domainMap = {
                'publishing_works': "lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_WORKS"
            }

            return this.$t(domainMap[notification.fromDomain])
        },
        getItemName(notification) {
            let domainMap = {
                'publishing_works': 'lang_PUBLISHING_CAPTION_WORKS'
            }

            return this.$t(domainMap[notification.fromDomain])
        },
        getStatusName(notification) {
            let statusMap = {
                'pending': "lang_LABEL_RELEASES_DIGITAL_DISTRIBUTION_STATUS_PENDING",
                'accepted': "lang_GENERIC_CAPTION_STATUS_ACCEPTED",
                'declined': "lang_GENERIC_CAPTION_STATUS_DECLINED",
                'failed': "lang_GENERIC_CAPTION_STATUS_FAILED"
            }

            return this.$t(statusMap[notification.status])
        },
        showActionsOnNotification(notification) {
            let allowedStatuses = ['pending', 'failed'];

            return allowedStatuses.includes(notification.status) && notification.isReceiver
        },
        searchByTag(notification) {
            const tag = notification.tagAssigned
            const domain = notification.toDomain

            let searchString = `TAG=[${tag}]`

            switch (domain) {
                case 'publishing_works':
                    this.$store.commit('setWorksSearch', searchString)
                    this.$store.commit('setExpandedWorks', [])
                    this.$router.push( { name: 'Works' })
                    break
            }
        },
        async dismissNotification(notification) {
            await this.$store.dispatch('dismissDataSharingNotification', { requestId: notification.id })
        },
    }
}
 </script>